import { render } from "./BreadcrumbsComponent.vue?vue&type=template&id=01052bd5&scoped=true"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=js"

import "./BreadcrumbsComponent.vue?vue&type=style&index=0&id=01052bd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01052bd5"]])

export default __exports__